module.exports = __webpack_public_path__ + "static/img/product_banner_15_zh.5e853c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_banner_15_zh.png
// module id = PL8x
// module chunks = 34